import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../CustomButton';
import { formatVehicleName, formatTimestamp, formatTimespanSeconds } from '../../../helpers/tablesFuncHelpers';
import '../../../common/MobileGridCards.sass';

const IdlingBreakdownMobileCard = ({ row, editVehicle }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const nameLabel = formatVehicleName(row.device_id, row);

	const baseData = [
		{ label: t('Group'), value: row.group_name },
		{ label: t(('Date/Time').replace(/\s/g, '_')), value: row.idling_ts ? formatTimestamp(row.idling_ts) : '-' },
		{ label: t('Duration'), value: formatTimespanSeconds(row.idling_duration) },
	];

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<CustomButton variant="link" onClick={(e) => editVehicle(e, row.device_id)}>{nameLabel}</CustomButton>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default IdlingBreakdownMobileCard;
